import api from './api';

const dentalService = {
    // ===== Price list =====
    getProcedures: async () => (await api.get('/dental/procedures')).data,
    createProcedure: async (data) => (await api.post('/dental/procedures', data)).data,
    updateProcedure: async (id, data) => (await api.put(`/dental/procedures/${id}`, data)).data,
    deleteProcedure: async (id) => (await api.delete(`/dental/procedures/${id}`)).data,

    // The patient's mouth as it stands: every tooth as the latest visit to
    // mention it left it.
    getPatientChart: async (patientId) => (await api.get(`/dental/patient/${patientId}/chart`)).data,

    // ===== Treatment plans =====
    // Each plan comes with its totals and where each instalment stands.
    getPatientPlans: async (patientId) => (await api.get(`/dental/patient/${patientId}/plans`)).data,
    createPlan: async (data) => (await api.post('/dental/plans', data)).data,
    updatePlan: async (id, data) => (await api.put(`/dental/plans/${id}`, data)).data,
    deletePlan: async (id) => (await api.delete(`/dental/plans/${id}`)).data,

    // ===== Payments =====
    // Also entered in the clinic's accounts.
    addPayment: async (planId, data) => (await api.post(`/dental/plans/${planId}/payments`, data)).data,
    deletePayment: async (planId, paymentId) => (await api.delete(`/dental/plans/${planId}/payments/${paymentId}`)).data,

    // Every treatment plan as an invoice. filters: { status, from, to, q }.
    getInvoices: async (filters = {}) => {
        const params = Object.fromEntries(Object.entries(filters).filter(([, value]) => value));
        return (await api.get('/dental/invoices', { params })).data;
    },

    // Every instalment still owed, earliest first.
    getInstallments: async () => (await api.get('/dental/installments')).data
};

export default dentalService;
